import clsx from "clsx"

import formatRecurrence from "@utils/formatRecurrence"

import { Table } from "@organisms"

import styles from "./RecurrenceCell.module.scss"
import { RecurrenceCellProps } from "./RecurrenceCell.types"

export default function RecurrenceCell(props: RecurrenceCellProps) {
    const { interval, frequency, startDate, weeklyRecurrence, monthlyRecurrence } = props

    if (!interval || !frequency || !startDate) {
        return <Table.Cells.NoValueCell />
    }

    return (
        <div className={clsx(styles.base)}>
            {formatRecurrence({ interval, frequency, startDate, weeklyRecurrence, monthlyRecurrence })}
        </div>
    )
}
